type FormData = {
    name: string;
    company?: string;
    mobileNumber: string;
    email?: string;
    services?: string;
    budget?: string;
    contractLength?: string;
    description?: string;
    howDidYouHearAboutUs?: string;
    currentSalary?: string;
    expectedSalary?: string;
    file?: string;
    resume?: string;
};
export function validate(data: FormData) {
    // Regex for validation
    // let phoneRegex = /^\s*(?:\+?60|0)1\d{1}(\s?\d{3,4}){2}\s*$/;
    // let phoneRegex = /^\d{9,14}$/;
    let phoneRegex = /^\+?[0-9][0-9\s-]{7,18}[0-9]$/;
    let emailRegex =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;
    let nameError: string | null = null;
    let companyError: string | null = null;
    let mobileNumberError: string | null = null;
    let emailError: string | null = null;
    let servicesError: string | null = null;
    let budgetError: string | null = null;
    let contractLengthError: string | null = null;
    let descriptionError: string | null = null;
    let howDidYouHearAboutUsError: string | null = null;
    let currentSalaryError: string | null = null;
    let expectedSalaryError: string | null = null;
    let fileError: string | null = null;
    let resumeError: string | null = null;

    if (data.name.trim() === "") {
        nameError = "Please enter your name";
    }
    if (!phoneRegex.test(data.mobileNumber)) {
        mobileNumberError = "Please enter a valid mobile number";
    }
    if (
        data.email?.trim() === "" ||
        (data.email && !emailRegex.test(data.email))
    ) {
        emailError = "Please enter a valid email address";
    }
    if (data.company?.trim() === "") {
        companyError = "Please enter a company name";
    }
    if (data.services && data.services.trim() === "") {
        servicesError = "Please select at least one services";
    }
    if (data.budget?.trim() === "") {
        budgetError = "Please select at least one budget";
    }
    if (data.contractLength?.trim() === "") {
        contractLengthError = "Please select at least one contract length";
    }
    if (data.description?.trim() === "") {
        descriptionError = "Please enter a description";
    }
    // In your validation function (@/utils/validation)
    if (!data.howDidYouHearAboutUs) {
        howDidYouHearAboutUsError = "Please select how you heard about us";
    } else if (data.howDidYouHearAboutUs === "Others") {
        howDidYouHearAboutUsError = "Please specify how you heard about us";
    }

    if (data.currentSalary?.trim() === "") {
        currentSalaryError = "Please enter your current salary";
    }
    if (data.expectedSalary?.trim() === "") {
        expectedSalaryError = "Please enter your expected salary";
    }
    if (data.file === null) {
        fileError = "Please upload your resume";
    }
    if (data.resume === null) {
        resumeError = "Please upload your resume";
    }
    return {
        nameError,
        mobileNumberError,
        emailError,
        companyError,
        servicesError,
        budgetError,
        contractLengthError,
        descriptionError,
        howDidYouHearAboutUsError,
        currentSalaryError,
        expectedSalaryError,
        fileError,
        resumeError,
    };
}
